import { createRouter, createWebHistory } from "vue-router";
import ChatBotView from "@/views/ChatbotView.vue";
import AboutChabotView from "@/views/AboutChabotView.vue";
import RessourcesView from "@/views/RessourcesView.vue";
import VersionChatbotView from "@/views/VersionChatbotView.vue";
import ModelTestingView from "@/views/ModelTestingView.vue";

const routes = [
  {
    path: "/",
    name: "Chatbot",
    component: ChatBotView,
  },
  {
    path: "/About",
    name: "À propos",
    component: AboutChabotView,
  },
  {
    path: "/Ressources",
    name: "Ressources",
    component: RessourcesView,
  },
  {
    path: "/Version",
    name: "Version",
    component: VersionChatbotView,
  },
  {
    path: "/modeltesting",
    name: "ModelTesting",
    component: ModelTestingView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
